import React from 'react';
import './header.css';
import { Link } from 'react-router-dom'
import { firstLetToUpperCase } from '../../helpers';
import { CHARACTERS, HOUSES, BOOKS } from '../../utils/constants';

const Header = () => (
  <div className="header-block">
    <h3 className="header-title">
      <Link to='/'>
        Game of Thrones DB
      </Link>
    </h3>
    <ul className="header-links">
      {[CHARACTERS, HOUSES, BOOKS].map((url, index) => (
        <li key={`${url}-${index}`}>
          <Link to={`/${url}/`} className="btn btn-primary">{firstLetToUpperCase(url)}</Link>
        </li>
      )
      )}
    </ul>
  </div>
)

export default Header